import { getWarehouses } from 'containers/Warehouses/warehousesSlice'
import { selectUserId } from 'containers/Login/loginSlice'
import { useReduxDispatch, useReduxSelector } from 'store'
import useAccessParams from '../hooks/useAccessParams'
import { useHistory } from 'react-router-dom'
import NewAccess from './NewAccess'
import { forwardRef } from 'react'
import MagAccessList from './List'

interface MagAccessProps {
  full?: boolean
  more?: basic.BasicFunc
}

const MagAccess = forwardRef<HTMLDivElement, MagAccessProps>((props, ref) => {
  const { id, action, typeId } = useAccessParams()
  const userId = useReduxSelector(selectUserId)

  const dispatch = useReduxDispatch()
  const { goBack } = useHistory()

  if (action) return (
    <NewAccess
      action={action}
      warehouseId={id}
      permissionId={typeId}
      callback={() => {
        goBack()
        dispatch(getWarehouses(userId))
      }}
    />
  )

  return (
    <MagAccessList
      ref={ref}
      {...props}
    />
  )
})

export default MagAccess